export const gravatar = hash => `https://www.gravatar.com/avatar/${hash}`;

export default {
  gravatar,
};
